import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { extractGamesFromController } from '@/utils/jackpotsV2/extractGamesFromController';
import { getJackpotsV2ForGames } from '@/utils/jackpotsV2/getJackpotsV2ForGames';

export const getJackpotsV2 = async (context: LogicContext) => {
  if (config?.features?.jackpotsV2?.mode !== 'enabled') {
    return {};
  }
  const { controllersData } = context;
  const allGames = extractGamesFromController(controllersData?.categories);
  const currency = context.user?.currency || config.default_currency;
  return getJackpotsV2ForGames(allGames, currency);
};
